var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbarStepper" }, [
    _vm.arrowIsAllow
      ? _c("img", {
          staticClass: "check-img",
          attrs: { src: require("@/assets/images/self-care/arrow-left.png") },
          on: { click: _vm.handleClickPrevPage },
        })
      : _vm._e(),
    _c("div", { staticClass: "navbarStepper_text" }, [
      _c("p", { staticClass: "grayLightMouse" }, [
        _vm._v(_vm._s(_vm.$t("Étape " + _vm.numberOfStep + " / 4"))),
      ]),
      _c("p", { staticClass: "grayLightMouse headline-medium" }, [
        _vm._v(_vm._s(_vm.$t(_vm.textOfStep))),
      ]),
    ]),
    _c("div", { staticClass: "progress-bar" }, [
      _vm.numberOfStep === 1
        ? _c("div", { staticClass: "step step1" })
        : _vm._e(),
      _vm.numberOfStep === 2
        ? _c("div", { staticClass: "step step2" })
        : _vm._e(),
      _vm.numberOfStep === 3
        ? _c("div", { staticClass: "step step3" })
        : _vm._e(),
      _vm.numberOfStep === 4
        ? _c("div", { staticClass: "step step4" })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }